import { blue05, blue10, blue20opacity20 } from '../../../colors/blue';
import { gray10, gray40opacity10, gray80 } from '../../../colors/gray';
import { green01, green02, green03, green02opacity20 } from '../../../colors/green';
import { orange03 } from '../../../colors/orange';
import { red02opacity20, red01 } from '../../../colors/red';
import { yellow01, yellow02, yellow02opacity20, yellow03 } from '../../../colors/yellow';
import { palette } from '../palette';
export var MuiAlert = {
    styleOverrides: {
        standard: {
            '& .MuiAlert-action': {
                color: palette.text.primary,
            },
        },
        standardInfo: {
            backgroundColor: blue20opacity20,
            color: blue05,
            '& .MuiAlert-icon': {
                color: blue10,
            },
        },
        standardSuccess: {
            backgroundColor: green02opacity20,
            color: green02,
            '& .MuiAlert-icon': {
                color: green03,
            },
        },
        standardWarning: {
            backgroundColor: yellow02opacity20,
            color: yellow02,
            '& .MuiAlert-icon': {
                color: yellow03,
            },
        },
        standardError: {
            backgroundColor: red02opacity20,
            color: red01,
            '& .MuiAlert-icon': {
                color: orange03,
            },
        },
        filledInfo: {
            backgroundColor: blue05,
            color: gray80,
        },
        filledSuccess: {
            backgroundColor: green01,
            color: gray80,
        },
        filledWarning: {
            backgroundColor: yellow01,
            color: gray80,
        },
        filledError: {
            backgroundColor: red01,
            color: gray80,
        },
    },
    customOverrides: {
        general: {
            backgroundColor: gray40opacity10,
            color: gray10,
        },
    },
};
